import React from "react";
import JobOrdersView from "./JobOrdersView";

const ArchivedJobOrders = () => <JobOrdersView archivedOnly />;

export default ArchivedJobOrders;
